export const ADDRESS = '17603 Pioneer Blvd Artesia, CA 90701'
export const ADDRESS_MAP_LINK = 'https://goo.gl/maps/1zUKq8oj9ayGceB29'
// add zoom to address with &zoom={<zoom_level>} zoom_level can range from 0 - 21
export const ADDRESS_EMBED_SRC = `https://www.google.com/maps/embed/v1/place?key=${process.env.GATSBY_GOOGLE_API_KEY}&q=Nilly's+Burgers,+17603+Pioneer+Blvd,+Artesia,+CA+90701`
